module.exports = __webpack_public_path__ + "img/leasing.70f8dfc1.png";